// extracted by mini-css-extract-plugin
export default {"placeholderFg":"BlurOverPaywall__placeholderFg___M52og","placeholderSizer":"BlurOverPaywall__placeholderSizer___CbX9K","unlockBtn":"BlurOverPaywall__unlockBtn___oNJO3"};